type QuizWithOptionalType = {
  type?: string | null;
};

type ResolveRestrictedMatchQuizIndexesParams = {
  quizList: readonly QuizWithOptionalType[];
  hasMatchAccess: boolean;
};

export const resolveRestrictedMatchQuizIndexes = ({
  quizList,
  hasMatchAccess,
}: ResolveRestrictedMatchQuizIndexesParams): number[] => {
  if (hasMatchAccess) {
    return [];
  }

  return quizList.reduce<number[]>((restrictedIndexes, quiz, index) => {
    if (quiz.type?.trim().toUpperCase() === 'MATCH') {
      restrictedIndexes.push(index);
    }

    return restrictedIndexes;
  }, []);
};
